<template>
    <div class="form-group">
        <label :for="myId" :class="labelWidth">{{ name | capitalize }}</label>
        <div v-if="isRow" :class="inputWidth">
            <select2 class="form-control w-100 tags" :class="{'border-danger': myErrors.length}" :value="myValue"
                @input="inputUpdate" @change="changeUpdate" :id="myId" :disabled="disabled" :placeholder="placeholder">
                <slot></slot>
            </select2>
        </div>
        <template v-else>
            <select2 class="form-control w-100 tags" :class="{'border-danger': myErrors.length}" :value="myValue"
                @input="inputUpdate" @change="changeUpdate" :id="myId" :disabled="disabled" :placeholder="placeholder">
                <slot></slot>
            </select2>
        </template>
        <div v-if="isRow" class="col-12">
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </div>
        <template v-else>
            <small class="form-text text-danger" v-for="(error, index) in myErrors" :key="index" v-text="error"></small>
        </template>
    </div>
</template>
<script>
    import InputBase from './InputBase';

    export default {
        extends: InputBase,
        methods: {

            inputUpdate(value) {
                this.myErrors = [];
                this.$emit('input', value);
            },

            changeUpdate(value) {
                this.myErrors = [];
                this.$emit('change', value);
            }
        }
    }
</script>
<style lang="">

</style>